module.exports = __webpack_public_path__ + "img/zh-Hans.f6609864.svg";